import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';

import { messages } from '../../Components/ServicePricingSection/ServicePricingSection.messages';

function PayoutAgreementDialog({ payoutAmount, currencyCode, onAccept, onDecline, onXClose }) {
  const dispatch = useDispatch();

  const handleClose = () => {
    onXClose();
    dispatch(closeModal());
  };
  const handleAccept = () => {
    onAccept();
    dispatch(closeModal());
  };
  const handleDecline = () => {
    onDecline();
    dispatch(closeModal());
  };

  return (
    <Confirm
      title={<Message message={messages.payoutAgreementTitle} />}
      cancelNode={<Message message={messages.payoutAgreementDecline} />}
      acceptNode={<Message message={messages.payoutAgreementAccept} />}
      onCancel={handleDecline}
      onConfirm={handleAccept}
      hasCloseButton
      onRequestClose={handleClose}>
      <p>
        <strong>
          <Message
            message={messages.payoutAgreementPayoutLine}
            values={{ payout: <Message as="span" format="currency" currency={currencyCode} value={payoutAmount} /> }}
          />
        </strong>
      </p>
      <p>
        <Message message={messages.payoutAgreementAgreement} />
      </p>
    </Confirm>
  );
}

PayoutAgreementDialog.propTypes = {
  payoutAmount: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  onXClose: PropTypes.func.isRequired,
};

export default PayoutAgreementDialog;
